import { ApiPath } from '@/common/app/api-path';
import {
  type BuyPaidLinePayload,
  type TwoTypesReward,
} from '@/common/types/earnRewardsType';
import {
  type ActivateVipStatusBuyLinkResponseType,
  type ActivateVipStatusResponseType,
} from '@/common/types/query/user';

import { api } from '../base';

const rewardsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRewards: builder.query<TwoTypesReward, void>({
      query: () => ApiPath.GET_REWARDS,
      keepUnusedDataFor: 600,
    }),
    claimEarnRewards: builder.mutation<TwoTypesReward, void>({
      query: () => ({
        url: ApiPath.CLAIM_EARN_REWARDS,
        method: 'POST',
      }),
    }),
    buyPaidLine: builder.mutation<
      ActivateVipStatusResponseType | ActivateVipStatusBuyLinkResponseType,
      BuyPaidLinePayload
    >({
      query: (data) => ({
        url: ApiPath.BUY_PAID_LINE,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

const {
  useLazyGetRewardsQuery,
  useClaimEarnRewardsMutation,
  useBuyPaidLineMutation,
} = rewardsApi;

export {
  rewardsApi,
  useBuyPaidLineMutation,
  useClaimEarnRewardsMutation,
  useLazyGetRewardsQuery,
};
